// src/utils/splitPhrase.ts

// Pole w rzędzie odpowiedzi gry Ułóż słowa: litera, którą uczeń układa (slotIndex to jej numer wśród liter hasła),
// albo znak, który nie jest literą (kropka, przecinek, apostrof, myślnik, cyfra…) i stoi od początku na swoim miejscu
export type PhraseCell =
  | { kind: 'letter', slotIndex: number }
  | { kind: 'fixed', char: string };

const LETTER = /\p{L}/u;

// Hasło rozbite na słowa (każde przechodzi do następnego rzędu pól w całości) i same litery do ułożenia.
// Spacje nie są polami — tylko dzielą hasło na słowa
export const splitPhrase = (phrase: string): { words: PhraseCell[][], letters: string[] } => {
  const letters: string[] = [];

  const words = phrase.split(/\s+/).filter(Boolean).map((word) => word.split('').map((char): PhraseCell => {
    if (!LETTER.test(char)) {
      return { kind: 'fixed', char };
    }

    letters.push(char);

    return { kind: 'letter', slotIndex: letters.length - 1 };
  }));

  return { words, letters };
};
